import React from 'react';
import RecentFiles from '../files/RecentFiles';
import ExploreSideBar from './ExploreSideBar';
import ExploreSideBarV2 from './ExploreSideBarV2';
import { RecentInstruments } from '../../instruments';
import FeatureFlags, {
  FeatureFlagKeys
} from '../../frontend-common-libs/src/components/feature_flags';

const Home = function Home() {
  const isLandingPageV2 = !!FeatureFlags().get(FeatureFlagKeys.LANDING_PAGE_V2);
  return (
    <div id="home-container">
      <div id="home-content">
        <RecentFiles />
        <RecentInstruments />
      </div>
      <div id="explore-sidebar">{isLandingPageV2 ? <ExploreSideBarV2 /> : <ExploreSideBar />}</div>
    </div>
  );
};

export default Home;
